import { sanitizeRedirect } from '@/lib/redirect';

export const DEFAULT_LOGIN_REDIRECT = '/';
export const EXTERNAL_AUTH_CONTINUATION = '/api/external-auth/continue';

export function resolveLoginContinuation(value?: string | null): string {
  return sanitizeRedirect(value) ?? DEFAULT_LOGIN_REDIRECT;
}

export function googleLoginOptions(value?: string | null) {
  return { callbackUrl: resolveLoginContinuation(value) };
}

export function navigateAfterSuccessfulLogin(
  value: string | null | undefined,
  replaceRoute: (target: string) => void,
  navigateDocument: (target: string) => void,
): void {
  const target = resolveLoginContinuation(value);

  if (target === EXTERNAL_AUTH_CONTINUATION) {
    navigateDocument(target);
    return;
  }

  replaceRoute(target);
}

export function safeLoginFailureMessage(translate: (key: string) => string): string {
  return translate('invalidCredentials');
}
